import React, { useState } from "react";
import { DynamicField } from "../../../components/ui/DynamicField";
import { TrainingModalInput } from "../../../config/allWorkout";
import UploadedBanner from "../../../components/common/UploadBanner";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";


const Training = ({
  exercise = {},
  trainingCategory = "",
  disabled,
  setSelectedVideoUrl,
  setSelectedImageUrl,
  weekIndex,
  dayIndex,
  setUploadedJson,
  exerciseindex
}) => {
  const { imageUrls, videoUrls } = useMediaStore();

  const dummyUrls = {
     video_url: videoUrls,
     image_url: imageUrls,
  };

  const [formValues, setFormValues] = useState({
    trainingCategory,
    ...exercise,
    // video_url: "",
    // image_url: "",
  });

  const handleFieldChange = (key, value) => {
    setUploadedJson((prev) => {
      let previous = { ...prev };
      // Ensure we update the correct category
      let categoryIndex = previous.weeks[weekIndex]['days'][dayIndex]['categories']
          .findIndex(cat => cat.sub_category === trainingCategory);

        if (categoryIndex !== -1) {
            previous.weeks[weekIndex]['days'][dayIndex]['categories'][categoryIndex]['exercises'][exerciseindex][key] = value;
        } else {
            console.error("Category not found for trainingCategory:", trainingCategory);
        }

        return previous;
    });
    setFormValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleSelectChange = (key, value) => {    
    setFormValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setUploadedJson((prev) => {
      let previous = { ...prev };
      // Ensure we update the correct category
      let categoryIndex = previous.weeks[weekIndex]['days'][dayIndex]['categories']
          .findIndex(cat => cat.sub_category === trainingCategory);

        if (categoryIndex !== -1) {
            previous.weeks[weekIndex]['days'][dayIndex]['categories'][categoryIndex]['exercises'][exerciseindex][key] = value;
        } else {
            console.error("Category not found for trainingCategory:", trainingCategory);
        }

        return previous;
    });

    if (key === "video_url") {
      setSelectedVideoUrl(value);
    } else if (key === "image_url") {
      setSelectedImageUrl(value);
    }
  };

  return (
    <div className="row mb-3">
      <div className="col-sm-8">
        <div className="row separator border p-3 rounded-sm">
          <div className="col-sm-12 mb-3">
            <DynamicField
              label="Sub-category"
              type="text"
              placeholder="Enter sub-category"
              value={formValues.trainingCategory || ""}
              onChange={(e) =>
                handleFieldChange("trainingCategory", e.target.value)
              }
            />
          </div>
        
          {TrainingModalInput.map((fieldConfig, index) => (
            <div className="col-sm-6 mb-3" key={index}>
            
              {fieldConfig.valueKey === "video_url" ||
              fieldConfig.valueKey === "image_url" ? (
                <div className="mb-3">


                        <SearchableSelectField
                          key={index}
                          label={fieldConfig.valueKey === "image_url" ? 'Image Name' : fieldConfig.valueKey === "video_url" ? 'Video Name': fieldConfig.label}
                          id={fieldConfig.valueKey}
                          options={dummyUrls[fieldConfig.valueKey]} 
                          value={formValues[fieldConfig.valueKey]}
                          disabled={fieldConfig.disabled}
                          onChange={(value) =>
                            handleSelectChange(fieldConfig.valueKey, value)
                          }
                        />

                  <div className="mt-2">
                    <label className="form-label">
                      Selected {fieldConfig.label}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={formValues[fieldConfig.valueKey] || ""}
                      onChange={(e) =>
                        handleFieldChange(fieldConfig.valueKey, e.target.value)
                      }
                      placeholder="Selected URL will appear here"
                      disabled={disabled}
                    />
                  </div>
                </div>
              ) : (
                <DynamicField
                  label={fieldConfig.label}
                  type={fieldConfig.type}
                  value={formValues[fieldConfig.valueKey] || ""}
                  placeholder={fieldConfig.placeholder}
                  options={fieldConfig.options}
                  defaultValue={fieldConfig.defaultValue}
                  onChange={(e) =>
                    handleFieldChange(fieldConfig.valueKey, e.target.value)
                  }
                  disabled={ !['exercise_number', 'name'].includes(fieldConfig.valueKey) }
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="col-sm-4">
        <UploadedBanner defaultImage={formValues.image_url} />
      </div>
    </div>
  );
};

export default Training;
